import { Injectable } from '@angular/core';

import { GeneralService } from 'app/services/data/general.service';
import { Observable } from 'rxjs';

@Injectable()

export class ContentResolver  {
    constructor(
        private generalService: GeneralService
    ) { }
    resolve(): Observable<boolean> {
        return this.generalService.fetchData$();
    }
}
